/**
 * Wire shape of the `user` field returned by /auth/login and /auth/me.
 * Mirrors what auth.controller.ts currently emits — keep it minimal so
 * additive backend changes don't break the parser.
 */
import { z } from 'zod';

export const UserRoleSchema = z.enum(['parent', 'tutor', 'admin']);
export type UserRole = z.infer<typeof UserRoleSchema>;

export const AuthUserSchema = z.object({
  id: z.string(),
  email: z.string().email(),
  role: UserRoleSchema,
  firstName: z.string(),
  lastName: z.string(),
  mustChangePassword: z.boolean(),
});
export type AuthUser = z.infer<typeof AuthUserSchema>;

export const LoginResponseSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string().optional(),
  user: AuthUserSchema,
});
export type LoginResponse = z.infer<typeof LoginResponseSchema>;

export const RefreshResponseSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string().optional(),
});
export type RefreshResponse = z.infer<typeof RefreshResponseSchema>;
